import React from "react";
import { Link } from "react-router-dom";

function PortfolioCard({ item }) {
  const Wrapper = item.external ? "a" : Link;
  const wrapperProps = item.external
    ? { href: item.link, target: "_blank", style: { textDecoration: "none" }, rel: "noreferrer" }
    : { to: item.link, style: { textDecoration: "none" } };

  return (
    <Wrapper {...wrapperProps}>
      <div className="Portfolio-images-section fade-in">
        <img src={item.image} alt={item.title} />
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "6%", marginBottom: "10%" }}>
        <div>
          <p className="fade-in" style={{ display: "flex", alignItems: "center" }}>{item.title}</p>
        </div>
        <div className="fade-in" style={{
          width: "40px",
          height: "40px",
          border: "1px solid white",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white"
        }}>
          <i className="ri-arrow-right-up-line"></i>
        </div>
      </div>
    </Wrapper>
  );
}

function EmptyState() {
  return (
    <div style={{ color: "white", padding: "40px", textAlign: "center", width: "100%", fontSize: "1.2rem", fontFamily: "DM Sans18ptLight" }}>
      No items found for this category.
    </div>
  );
}

function StandardGrid({ filteredItems }) {
  return (
    <div className="images-section">
      {filteredItems.map((item, index) => (
        <PortfolioCard key={index} item={item} />
      ))}
      {filteredItems.length === 0 && <EmptyState />}
    </div>
  );
}

function PortfolioGrid({ activeCategory, activeSubCategory, filteredItems }) {
  const showHeading =
    (activeCategory !== "All" && activeCategory !== "AI / IoT / Analytics") ||
    (activeCategory === "Web Application" && activeSubCategory !== "All") ||
    (activeCategory === "AI / IoT / Analytics" && activeSubCategory !== "All");

  const headingLabel =
    activeCategory === "Web Application" && activeSubCategory !== "All"
      ? activeSubCategory
      : activeCategory;

  return (
    <>
      {showHeading && (
        <h2 style={{
          color: "white",
          textAlign: "center",
          marginTop: "20px",
          marginBottom: "20px",
          fontSize: "28px",
          fontFamily: "'DM Sans_18pt-Light', sans-serif",
          fontWeight: "500",
          letterSpacing: "1px",
          textTransform: "uppercase"
        }}>
          {headingLabel}
        </h2>
      )}

      <div className="portfoliotabswidth">
        <div className="All-Section">
          <StandardGrid filteredItems={filteredItems} />
        </div>
        <div className="portfoliotabsbottom"></div>
      </div>
    </>
  );
}

export default PortfolioGrid;
